/* src/app/shared/components/changes-history/changes-history.component.scss */
.changes {
  width: 60%;
}
/*# sourceMappingURL=changes-history.component.css.map */
